export { default } from "ember-stereo/modifiers/sound-position-progress";
